
import "./style.css";
import React, {useState, useEffect} from 'react';
import { Grid, Typography, Button, Dialog, LinearProgress, DialogTitle, DialogContent, DialogContentText, DialogActions, Box, Card, CardContent,FormControlLabel, CardActions, Switch, Checkbox, MenuItem, Paper, TableContainer, Table, TableHead, TableCell, TableBody, TableRow } from '@mui/material';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import PIList from '../../PIList';
import TextField from '@mui/material/TextField'; 
import {useNavigate} from "react-router-dom";
import Select from '@mui/material/Select'
import {read} from "../../PaidInvoiceList/api.js";
import {readEmpty} from "../../PaidInvoiceList/apiEmpty.js";
import CloseIcon from '@mui/icons-material/Close';
import axios from "axios";
import CheckIcon from "@mui/icons-material/Check";
import Autocomplete from '@mui/material/Autocomplete';
import { useSelector } from 'react-redux';

const Step3 = (props) => {
    const [loadVisibility, setLoadVisibility] = useState(false)
    const [previewVisibility, setPreviewVisibility] = useState(false)
    const [currPreview,setCurrPreview] = useState("none")
    const [selectedSales, setSelectedSales] = useState();
    const [fileURL, setFileURL] = useState("");
    const handleClosePreview = (event) =>{
      setPreviewVisibility(false)
      setCurrPreview("none")
    }
    const history = useNavigate();
    const [selectedPackage, setSelectedPackage] = useState(null);
    const [posts, setPosts] = useState([])
    const [isEnd,setIsEnd] = useState("loading..")
    const [skip, setSkip] = useState(0)
    const [searchThis, setsearchThis] = useState("billTo")
    const [query,setQuery] = useState("")
    const nowstate = useSelector(state => state);

    const newFetchPosts = async (event) => {
      setPosts([])
      setIsEnd("Loading...");
      if(event.target.value.trim()){
      try{
          const { data, error } = await read(skip,event.target.value,searchThis,nowstate.user.sales);
          if(error){
              console.log(error.message);
              return;
          }

          if(data?.length === 0){
              setIsEnd("Selesai...");
              return;
          }
          
          //success
          setPosts([...data])
      }catch(error){
          console.log(error.message);
      }
      }else{
          console.log("empty")
          try{
              const { data, error } = await readEmpty(skip,nowstate.user.sales);
              if(error){
                  console.log(error.message);
                  return;
              }
  
              if(data?.length === 0){
                  setIsEnd("Selesai...");
                  return;
              }
              
              //success
              setPosts([...posts, ...data])
          }catch(error){
              console.log(error.message);
          } 
      }
  }
    async function newPI(e){
    }
    const handleSearch = (event) =>{
      setQuery(event.target.value)
      setSkip(0)
      newFetchPosts(event)
    }
    useEffect(() => {
      fetchPosts();
  }, [skip,query]);
  const fetchPosts = async () => {
    if(query.trim()){
            try{
                const { data, error } = await read(skip,query,searchThis);
                if(error){
                    console.log(error.message);
                    return;
                }
    
                if(data?.length === 0){
                    setIsEnd("Selesai...");
                    return;
                }
                
                //success
                setPosts([...posts, ...data])
            }catch(error){
                console.log(error.message);
            }
        
    }else{

    try{
        const { data, error } = await readEmpty(skip,query);
        if(error){
            console.log(error.message);
            return;
        }

        if(data?.length === 0){
            setIsEnd("Selesai...");
            return;
        }
        
        //success
        setPosts([...posts, ...data])
    }catch(error){
        console.log(error.message);
    } 
    }
}
    const searchSelected = async (event)=>{
      setsearchThis(event.target.value)
    }

    const handlePackageClick = (index) => {
        setSelectedPackage(index);
      };

      const previewPDF = async (post) => {
        console.log("diatas")
        setCurrPreview(post)
        setLoadVisibility(true)
        const currid = post._id
    
        axios.get(`${process.env.REACT_APP_BACKEND_URL}/previewpdfpaid?currid=${currid}&dbwhatToPreview=proformainvoiceDB`,{
            method: "GET",
            responseType: "blob"
        }).then(resp => {
                    console.log(resp)
                        const blob = new Blob([resp.data], { type: 'application/pdf' })
                    // saveAs(blob);
                    var fileURLNew = URL.createObjectURL(blob);
                    console.log(fileURLNew)
                    setPreviewVisibility(true)
                    setLoadVisibility(false)
                    setFileURL(fileURLNew)
                })
                

            

        
        
        console.log("2")
    
    }

    const handleScroll = (e) => {
      const { offsetHeight, scrollTop, scrollHeight } = e.target;

      if(offsetHeight + scrollTop >= scrollHeight){
          setSkip(posts?.length);
      }
  }
    const [state, setState] = useState({
      gilad: false,
      jason: false,
      antoine: true,
    });
    const [error,setError] = useState(null)
    const checkpaket = (event) =>{
      if(props.selectedPost.packageTitle !== "Virtual Office" && props.selectedPost.packageTitle !== "Call Center"){
        if(selectedSales) { 
          props.nextButton({
            ...props.selectedPost,
            invoicetoLink: {
              Inquiry:{
                Sales: selectedSales
              }
            }
          })
        }else{
          setError("Isi Sales jika tidak ada pembayaran sebelumnya")
        }
      }else{
        setError(props.selectedPost.packageTitle + " harus payment dahulu")
      }      
    }
    const [sales, setSales]= useState(["Adnan", "Diva", "Felly", "Reinner", "Dinda", "Lainnya"])
    const label = { inputProps: { 'aria-label': 'Switch demo' } };
    const [status,setStatus] = useState("No")
    const switchChange = (event) => {
      setSelectedSales("")
      setState({
        ...state,
        [event.target.name]: event.target.checked,
      });
      if(status === "No"){
        setStatus("Yes")
      }else{
        setStatus("No")
      }
    }
    const linkInvoice = (event) =>{
      props.nextButton({...props.selectedPost, invoicetoLink: currPreview})
    }
    if (props.currentStep !== 3) {
        return null;
      }

      const renderPackageCard = (index, title, disabled = false) => (
        <Card
          onClick={disabled ? null : () => handlePackageClick(index)}
          sx={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            borderColor: selectedPackage === index ? 'primary.main' : 'divider',
            borderWidth: 1,
            borderStyle: 'solid',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            backgroundColor: disabled ? 'action.disabledBackground' : 'background.paper',
            opacity: disabled ? 0.5 : 1,
          }}
        >
          <CardContent>
            <Typography variant="h5">{title}</Typography>
          </CardContent>
          {selectedPackage === index && !disabled && (
            <CardActions>
              <CheckCircleOutlineIcon color="primary" />
            </CardActions>
          )}
        </Card>
      );
    return (<Grid>
    <Dialog open={loadVisibility} aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "100px",  // Set your width here
                        },
                    },}}>
                    <DialogContent>
                    <Box sx={{ width: '100%' }}>
                        <LinearProgress />
                    </Box>
                    </DialogContent>
    </Dialog>
    <Dialog
                    open={previewVisibility}
                    onClose={handleClosePreview}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{"& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                        width: "100%",
                        maxWidth: "1250px",  // Set your width here
                        },
                    },}}
                                >
                    <DialogTitle id="alert-dialog-title">
                        <Button onClick={handleClosePreview} autoFocus>
                            <CloseIcon></CloseIcon>
                        </Button>
                    </DialogTitle>
                    <DialogContent>
                    <iframe src={fileURL} width="1200" height="500"></iframe>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                    <Button onClick={linkInvoice}>
                        Hubungkan dengan Invoice ini
                    </Button>
                    </DialogActions>
                </Dialog>
    <Grid container>
      <Grid item xs={7}><Typography variant="h6">Apakah sudah melakukan pembayaran?</Typography></Grid>
      <Grid>
        <FormControlLabel control={<Switch checked={state.gilad} onChange={switchChange} name="gilad"/>} label={status} />
      </Grid>
    </Grid>
    {status === "Yes" && (
    <Grid container sm={{mt:5}}>
      <Grid item xs={2}>
        <Select  fullWidth value={searchThis} onChange={event => searchSelected(event)}><MenuItem value="billTo">Company</MenuItem><MenuItem value="shipTo">PIC</MenuItem><MenuItem value="piAmount">No. PI</MenuItem></Select>
      </Grid>
      <Grid item xs={8}>
        <TextField value={query} onChange={event => handleSearch(event)} fullWidth />
      </Grid>


      <Grid container align = "center" justify = "center" alignItems = "center">
                            <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                                <TableContainer sx={{ maxHeight: 440, minHeight: 440 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                    <Table stickyHeader aria-label="sticky table">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell style={{ width: 200 }}>
                                                    Tanggal
                                                </TableCell>
                                                <TableCell>
                                                    Bill To (Company)
                                                </TableCell>
                                                <TableCell>
                                                    Bill To (PIC)
                                                </TableCell>
                                                <TableCell>
                                                    Nomor PI
                                                </TableCell>
                                                <TableCell style={{ width: 25 }}>
                                                </TableCell>
                                                <TableCell style={{ width: 25 }}>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        {posts?.map((post) => (
                                            <TableBody>
                                                <TableRow hover>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.tanggalPI}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.billTo}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.shipTo}</p>
                                                    </TableCell>
                                                    <TableCell onClick={()=> previewPDF(post)} style={{cursor:'pointer'}}>
                                                        <p>{post.piAmount}</p>
                                                    </TableCell>
                                                    <TableCell>
                                                    
                                                    </TableCell>
                                                    <TableCell>
                                                        
                                                    </TableCell>
                                                </TableRow>
                                            </TableBody>
                                        ))}
                                        {isEnd}
                                    </Table>
                                </TableContainer>
                            </Paper>
                                
                            </Grid>

    </Grid>)}
    {status === "No" && (
      <Grid>
      <Grid sm={2}>
                    Sales*:
                </Grid>
                <Grid sm={7}>
                    <Autocomplete
                                    sx={{ width: 360 }}
                                    options={sales}
                                    freeSolo
                                    getOptionLabel={(option) => option}
                                    disableCloseOnSelect
                                    value={selectedSales}
                                    onChange={(event, newValue) => {
                                        setSelectedSales(newValue);
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Pilih Sales"
                                        placeholder="Pilih Sales"
                                        />
                                    )}
                                    renderOption={(props, option, { selected }) => (
                                        <MenuItem
                                        {...props}
                                        key={option}
                                        value={option}
                                        sx={{ justifyContent: "space-between" }}
                                        >
                                        {option}
                                        {selected ? <CheckIcon color="info" /> : null}
                                        </MenuItem>
                                    )}
                                    />                
                    </Grid>

      </Grid>
    )}
    {error && <div className="error_text">{error}</div>}
    <Grid container>
    <Grid item md={6}>
        <Button sx={{ mt: 5 }} onClick={() => props.prevButton()} size="medium" type="button" variant="contained">Previous</Button>
      </Grid>
      {status === "No" && (
      <Grid  container md={6} justifyContent="flex-end">
        <Button sx={{ mt: 5 }} onClick={() => checkpaket()} size="medium" type="button" variant="contained">Next</Button>
      </Grid>
      )}
    </Grid>
    
    </Grid>);};

    export default Step3;
